import { Divider } from '../styled-components'

const ContextMenuDivider = () => {
  return <Divider />
}

export default ContextMenuDivider
